/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import moment from "moment";
import {
  Row,
  Col,
  Form,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import { nameValidation, numberValidation } from "../../utils/helperFunction";

import Config from "../../utils/config";
import CustomDatepicker from "../CustomDatepicker";
import history from "../../history.js";
import InputText from "../InputText";
import CartTitle from "../CartTitle";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomButton from "../CustomButton";
import Loader from "../Loader";

import get from "lodash/get";

const _ = { get };

const initialState = {
  gender: "Other",
  fName: "",
  lName: "",
  email: "",
  dob: "",
  mobile: "",
  locality: null,
  countryCode: "",
  callingCode: "",
  becomeMember: false,
  promotionsnews: false,
  acceptTC: false,
  surveysandresearch: false,
  communityactivities: false,
  allpromotions: false,
  donotphone: true,
  donotemail: true,
  userType: false,
};

export default function userCreation(props) {
  let { elements } = props;
  const [state, setState] = useState(initialState);

  useEffect(() => {
    props.handleCountryMobileCodeFetch();
    state.email = sessionStorage.getItem("userRegistrationEmail");
    state.mobile = sessionStorage.getItem("userRegistrationPhone");
    setState({ ...state });
  }, []);

  const handleRegDateChange = (date) => {
    state.dob = date;
    setState({ ...state });
  };

  const handleGenderChange = (e, status, id) => {
    state.gender = status;
    setState({ ...state });
  };

  const handleTermsAndConditions = (e, item) => {
    if (item === "Phone") state.donotphone = !state.donotphone;
    if (item === "Email") state.donotemail = !state.donotemail;

    if (item === "becomeMember") {
      state.becomeMember = !state.becomeMember;
      state.communityactivities = state.becomeMember;
    }

    if (item === "Surveys") {
      state.surveysandresearch = !state.surveysandresearch;
      state.allpromotions = false;
    }

    if (item === "communityactivities" && state.becomeMember !== true) {
      state.communityactivities = !state.communityactivities;
      state.allpromotions = false;
    }

    if (item === "Promotion") {
      state.promotionsnews = !state.promotionsnews;
      state.allpromotions = false;
    }
    if (item === "All") {
      state.allpromotions = !state.allpromotions;
      state.communityactivities =
        state.becomeMember !== true
          ? state.allpromotions === true
            ? true
            : false
          : true;
      state.surveysandresearch = state.allpromotions === true ? true : false;
      state.promotionsnews = state.allpromotions === true ? true : false;
    }
    if (item === "TC") state.acceptTC = !state.acceptTC;
    setState({ ...state });
  };

  const handleNameChange = (e, id) => {
    let value = e.target.value;
    if (id === "name") {
      if (value.match(nameValidation)) {
        state[e.target.name] = value;
      }
    }
    if (id === "number") {
      if (value.match(numberValidation)) {
        state[e.target.name] = value;
      }
    }
    if (id === "all") {
      state[e.target.name] = value;
    }
    setState({ ...state });
  };

  const handleCountryChange = (e) => {
    if (e.target.value !== "Select Country") {
      let parsedValue = JSON.parse(e.target.value);
      state.locality = parsedValue.locality;
      setState({ ...state });
    } else {
      state.locality = null;
      setState({ ...state });
    }
  };

  const handleBackButton = () => {
    history.goBack();
  };

  const handleCountryChangeMobileCode = (e) => {
    let parsedValue = JSON.parse(e.target.value);
    let value = parsedValue.phone_code;
    state.callingCode = value;
    setState({ ...state });
  };

  const handleExistingUser = (e, id) => {
    if (id === "Yes") {
      state.userType = true;
    } else {
      state.userType = false;
    }
    setState({ ...state });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (state.becomeMember !== false) {
      sessionStorage.setItem("member", "TRUE");
    } else {
      sessionStorage.setItem("member", "FALSE");
    }

    let dataForRegister = {
      fName: state.fName ? state.fName.trim() : "",
      lName: state.lName ? state.lName.trim() : "",
      gender: state.gender,
      dob: moment(state.dob).format("YYYY-MM-DD"),
      email: state.email ? state.email.trim() : "",
      locality: state.locality,
      mobile: state.mobile ? state.mobile.trim() : "",
      callingCode: state.callingCode,
      makeMember: state.becomeMember,
      userType: state.userType,
    };
    let dataForConsents = {
      promotionsnews: state.promotionsnews,
      terms_and_conditions: state.acceptTC,
      surveysandresearch: state.surveysandresearch,
      communityactivities: state.communityactivities,
      allpromotions: state.allpromotions,
      donotphone: state.donotphone,
      donotemail: state.donotemail,
    };

    let data = {
      dataForRegister,
      dataForConsents,
    };

    if (state.fName === "")
      return toast.error(
        _.get(
          elements,
          "userCreationElements.firstNameValidationElement",
          "Enter First Name"
        )
      );
    if (state.lName === "")
      return toast.error(
        _.get(
          elements,
          "userCreationElements.lastNameValidationElement",
          "Enter Last Name"
        )
      );
    if (state.dob === "")
      return toast.error(
        _.get(
          elements,
          "userCreationElements.dobValidationElement",
          "Date of Birth not selected"
        )
      );
    if (data.dataForRegister.locality === null)
      return toast.error(
        _.get(
          elements,
          "userCreationElements.countryValidationElement",
          "Country not selected"
        )
      );
    if (data.dataForRegister.callingCode === "")
      return toast.error(
        _.get(
          elements,
          "userCreationElements.callingCodeValidationElement",
          "Calling code not selected"
        )
      );

    if (state.acceptTC === false)
      return toast.error(
        _.get(
          elements,
          "userCreationElements.termAndConditionValidationElement",
          "Please Accept terms and conditions"
        )
      );

    return props.handleCreateUser(data);
    // return console.log(data);
  };
  return (
    <div className="hideSearch">
      {props.createUserStatus !== false ? <Loader /> : null}
      {props.registerConsentForm !== false ? <Loader /> : null}
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col sm={12}>
            <CartTitle
              title={_.get(
                elements,
                "userCreationElements.headingElement",
                "User Registration"
              )}
              customClass={"hidebtn"}
              iconClass={"hideexcel"}
              innerTextClass={"hidetext"}
            />
          </Col>
        </Row>
        <Card className="mb-3">
          <CardBody>
            <Row>
              <Col md="12">
                <h3 className="title-bar secondary-title f-weight-bold mb-3 pb-2 themeColor"></h3>
              </Col>
              <Col xl={4} lg={4} md={6} sm={6} className="mb-2">
                <InputText
                  labelName={_.get(
                    elements,
                    "userCreationElements.fNameLabel",
                    "First Name*"
                  )}
                  customValue={state.fName}
                  inputType={"text"}
                  inputName={"fName"}
                  InputClass={"my-2 inputText"}
                  inputPlaceholder={_.get(
                    elements,
                    "userCreationElements.fNamePlaceholder",
                    "First Name"
                  )}
                  customMaxLength={20}
                  customOnChange={(e) => handleNameChange(e, "name")}
                />
              </Col>
              <Col xl={4} lg={4} md={6} sm={6} className="mb-2">
                <InputText
                  labelName={_.get(
                    elements,
                    "userCreationElements.lNameLabel",
                    "Last Name*"
                  )}
                  inputType={"text"}
                  customValue={state.lName}
                  inputName={"lName"}
                  InputClass={"my-2 inputText"}
                  inputPlaceholder={_.get(
                    elements,
                    "userCreationElements.lNamePlaceholder",
                    "Last Name"
                  )}
                  customMaxLength={20}
                  customOnChange={(e) => handleNameChange(e, "name")}
                />
              </Col>
              <Col xl={4} lg={4} md={6} sm={12} className="mb-4">
                <Label className="inputLabel" for="exampleCheckbox">
                  {_.get(
                    elements,
                    "userCreationElements.selectGenderLabel",
                    "Select Your Gender*"
                  )}
                </Label>
                <FormGroup>
                  <div className="defaultbtn customCheck mt-2 flex-column flex-sm-row   justify-content-center  align-items-center justify-content-lg-start  align-items-lg-start">
                    <Button
                      type="button"
                      className={`btn-outline-dark bg-none checkbtn mb-2 mb-lg-0 mr-0 mr-sm-2 ${
                        state.gender === "Male" ? "btnthemeColor" : ""
                      }`}
                      onClick={(e) => handleGenderChange(e, "Male")}
                    >
                      {_.get(
                        elements,
                        "userCreationElements.maleElement",
                        "Male"
                      )}
                    </Button>
                    <Button
                      type="button"
                      className={`btn-outline-dark bg-none checkbtn mb-2 mb-lg-0 mr-0 mr-sm-2 ${
                        state.gender === "Female" ? "btnthemeColor" : ""
                      }`}
                      onClick={(e) => handleGenderChange(e, "Female")}
                    >
                      {_.get(
                        elements,
                        "userCreationElements.femaleElement",
                        "Female"
                      )}
                    </Button>
                    <Button
                      type="button"
                      className={`btn-outline-dark bg-none checkbtn mb-2 mb-lg-0 ${
                        state.gender === "Other" ? "btnthemeColor" : ""
                      }`}
                      onClick={(e) => handleGenderChange(e, "Other")}
                    >
                      {_.get(
                        elements,
                        "userCreationElements.otherElement",
                        "Prefer not to say"
                      )}
                    </Button>
                  </div>
                </FormGroup>
              </Col>
              <Col xl={4} lg={6} md={6} sm={6} className="mb-4">
                <Label className="inputLabel">
                  {_.get(
                    elements,
                    "userCreationElements.dobLabel",
                    "Date Of Birth*"
                  )}
                </Label>
                <FormGroup className="mt-1 pt-1">
                  <CustomDatepicker
                    value={state.dob}
                    customPlaceHolder={_.get(
                      elements,
                      "userCreationElements.dobPlaceholder",
                      "Select Date"
                    )}
                    handleDateChange={handleRegDateChange}
                    customShowMonthDropdown={true}
                    customShowYearDropdown={true}
                    customMaxDate={moment()
                      .subtract(14, "years")
                      .toDate()}
                  />
                </FormGroup>
              </Col>
              <Col xl={4} lg={6} md={6} sm={6} className="mb-4">
                <InputText
                  labelName={_.get(
                    elements,
                    "userCreationElements.emailLabel",
                    "Email*"
                  )}
                  inputType={"email"}
                  customValue={state.email}
                  inputName={"email"}
                  InputClass={"my-2 inputText"}
                  inputPlaceholder={_.get(
                    elements,
                    "userCreationElements.emailPlaceholder",
                    "Email"
                  )}
                  customOnChange={(e) => handleNameChange(e, "all")}
                  disabledType={true}
                />
              </Col>
              <Col xl={4} lg={4} md={6} sm={6} className="mb-2">
                <Label className="inputLabel">
                  {_.get(
                    elements,
                    "userCreationElements.countryLabel",
                    "Country*"
                  )}
                </Label>
                <FormGroup className="mt-1 pt-1">
                  <Input
                    type="select"
                    name="City"
                    className="w-100 customeSelectBtn"
                    onChange={handleCountryChange}
                  >
                    <option value="Select Country">
                      {_.get(
                        elements,
                        "userCreationElements.selectCountryElement",
                        "Select Country"
                      )}
                    </option>
                    {props.country.map((item, index) => (
                      <option key={index} value={JSON.stringify(item)}>
                        {item.country}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col xl={4} lg={4} md={6} sm={6} className="mb-2">
                <Label className="inputLabel">
                  {_.get(
                    elements,
                    "userCreationElements.callingCodeLabel",
                    "Calling Code*"
                  )}
                </Label>
                <FormGroup className="mt-1 pt-1">
                  <Input
                    type="select"
                    name="City"
                    className="w-100 customeSelectBtn"
                    onChange={handleCountryChangeMobileCode}
                  >
                    <option value="Select Calling Code">
                      {_.get(
                        elements,
                        "userCreationElements.selectCallingCodeElement",
                        "Select Calling Code"
                      )}
                    </option>
                    {props.countryMobileCode &&
                      props.countryMobileCode.map((item, index) => (
                        <option key={index} value={JSON.stringify(item)}>
                          {`${item.name} (${"+"}${item.phone_code})`}
                        </option>
                      ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col xl={4} lg={4} md={6} sm={6} className="mb-2">
                <InputText
                  labelName={_.get(
                    elements,
                    "userCreationElements.mobileLabel",
                    "Mobile Number*"
                  )}
                  inputType={"tel"}
                  inputName={"mobile"}
                  InputClass={"my-2 inputText"}
                  customValue={state.mobile}
                  inputPlaceholder={_.get(
                    elements,
                    "userCreationElements.mobilePlaceholder",
                    "Mobile Number"
                  )}
                  customOnChange={(e) => handleNameChange(e, "number")}
                  disabledType={true}
                />
              </Col>
              <Col md={11} className="mt-3">
                <span>
                  <strong>
                    {_.get(
                      elements,
                      "userCreationElements.clubMemberLabel",
                      "Club Member"
                    )}
                    :
                  </strong>
                </span>
                <Row>
                  <Col sm={12} md={8}>
                    <FormGroup className="d-flex align-items-center">
                      <div className="defaultbtn customCheck   checkbtn">
                        <Button
                          type="button"
                          className={`btn-outline-dark bg-none  mr-2 ${
                            state.becomeMember === true ? "btnthemeColor" : ""
                          }`}
                          onClick={(e) =>
                            handleTermsAndConditions(e, "becomeMember")
                          }
                        ></Button>
                      </div>
                      <div className="">
                        <span>
                          {_.get(
                            elements,
                            "userCreationElements.clubMemberDescription",
                            "Make me a member of the Riders Club"
                          )}
                        </span>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
              {/* <Col md={11} className="mt-3">
                <span>
                  <strong>
                    { _.get(
                      elements,
                      "userCreationElements.methodOfContactLabel",
                      "Method of Contact"
                    ) }
                    :
                  </strong>
                </span> */}
              {/* <Row>
                  <Col xl={4} sm={6} md={3}>
                    <FormGroup className="d-flex align-items-center">
                      <div className="defaultbtn customCheck   checkbtn">
                        <Button
                          type="button"
                          className={ `btn-outline-dark bg-none  mr-2 ${state.donotphone === false ? "btnthemeColor" : ""
                            }` }
                          onClick={ (e) => handleTermsAndConditions(e, "Phone") }
                        ></Button>
                      </div>
                      <div className="">
                        <span>
                          { _.get(
                            elements,
                            "userCreationElements.methodOfContactPhone",
                            "Phone"
                          ) }
                        </span>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col xl={ 4 } sm={ 6 } md={ 3 }>
                    <FormGroup className="d-flex align-items-center">
                      <div className="defaultbtn customCheck   checkbtn">
                        <Button
                          type="button"
                          className={ `btn-outline-dark bg-none  mr-2 ${state.donotemail === false ? "btnthemeColor" : ""
                            }` }
                          onClick={ (e) => handleTermsAndConditions(e, "Email") }
                        ></Button>
                      </div>
                      <div className="">
                        <span>
                          { _.get(
                            elements,
                            "userCreationElements.methodOfContactEmail",
                            "Email"
                          ) }
                        </span>
                      </div>
                    </FormGroup>
                  </Col>
                </Row> */}
              {/* </Col> */}
              <Col md={11} className="mt-3">
                <span>
                  <strong>
                    {_.get(
                      elements,
                      "userCreationElements.futureContactLabel",
                      "Future Contact"
                    )}
                    :
                  </strong>
                </span>
                <Row>
                  <Col xl={3} sm={6} md={3}>
                    <FormGroup className="d-flex align-items-center">
                      <div className="defaultbtn customCheck   checkbtn">
                        <Button
                          type="button"
                          className={`btn-outline-dark bg-none  mr-2 ${
                            state.communityactivities === true
                              ? "btnthemeColor"
                              : ""
                          }`}
                          onClick={(e) =>
                            handleTermsAndConditions(e, "communityactivities")
                          }
                        ></Button>
                      </div>
                      <div className="">
                        <span>
                          {_.get(
                            elements,
                            "userCreationElements.futureContactCommunity",
                            "Community Activities"
                          )}
                        </span>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col xl={3} sm={6} md={3}>
                    <FormGroup className="d-flex align-items-center">
                      <div className="defaultbtn customCheck   checkbtn">
                        <Button
                          type="button"
                          className={`btn-outline-dark bg-none  mr-2 ${
                            state.promotionsnews === true ? "btnthemeColor" : ""
                          }`}
                          onClick={(e) =>
                            handleTermsAndConditions(e, "Promotion")
                          }
                        ></Button>
                      </div>
                      <div className="">
                        <span>
                          {_.get(
                            elements,
                            "userCreationElements.futureContactPromotion",
                            "Promotion & News"
                          )}
                        </span>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col xl={3} sm={6} md={3}>
                    <FormGroup className="d-flex align-items-center">
                      <div className="defaultbtn customCheck   checkbtn">
                        <Button
                          type="button"
                          className={`btn-outline-dark bg-none  mr-2 ${
                            state.surveysandresearch === true
                              ? "btnthemeColor"
                              : ""
                          }`}
                          onClick={(e) =>
                            handleTermsAndConditions(e, "Surveys")
                          }
                        ></Button>
                      </div>
                      <div className="">
                        <span>
                          {_.get(
                            elements,
                            "userCreationElements.futureContactSurveys",
                            "Surveys & Research"
                          )}
                        </span>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col xl={3} sm={6} md={3}>
                    <FormGroup className="d-flex align-items-center">
                      <div className="defaultbtn customCheck   checkbtn">
                        <Button
                          type="button"
                          className={`btn-outline-dark bg-none  mr-2 ${
                            state.allpromotions === true ? "btnthemeColor" : ""
                          }`}
                          onClick={(e) => handleTermsAndConditions(e, "All")}
                        ></Button>
                      </div>
                      <div className="">
                        <span>
                          {_.get(
                            elements,
                            "userCreationElements.futureContactAll",
                            "All"
                          )}
                        </span>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>{" "}
              <Col md={11} className="mt-3 mx-auto ">
                <span>
                  <strong>
                    {_.get(
                      elements,
                      "userCreationElements.disclaimerLabel",
                      "Disclaimer"
                    )}
                    :
                  </strong>{" "}
                  {_.get(
                    elements,
                    "userCreationElements.disclaimerDescription",
                    `By signing this form/checking this box, you acknowledge and
                    agree that we may use the information you share with us, to
                    communicate with you through e-mails, text messages and calls,
                    in order to provide our product or service related information
                    and/or for promotional and marketing purposes. All information
                    provided will be secured and processed as per our`
                  )}
                </span>
                <FormGroup className="d-flex align-items-center mt-3 mt-lg-0">
                  <div className="defaultbtn customCheck   checkbtn">
                    <Button
                      type="button"
                      className={`btn-outline-dark bg-none  mr-2 ${
                        state.acceptTC === true ? "btnthemeColor" : ""
                      }`}
                      onClick={(e) => handleTermsAndConditions(e, "TC")}
                    ></Button>
                  </div>
                  <div className="">
                    <span>
                      {_.get(
                        elements,
                        "userCreationElements.iAcceptElement",
                        "I accept the"
                      )}
                      <a
                        href={`${Config.imageBaseUrl}/uk/en/legal/terms-and-conditions/`}
                        target="_blank"
                        className="text-dark"
                      >
                        <strong>
                          {_.get(
                            elements,
                            "userCreationElements.termAndConditionElement",
                            " Terms and Conditions "
                          )}
                        </strong>
                      </a>
                      {_.get(
                        elements,
                        "userCreationElements.asWellAsElement",
                        " as well as "
                      )}

                      <a
                        href={`${Config.imageBaseUrl}/uk/en/legal/privacy-policy/`}
                        target="_blank"
                        className="text-dark"
                      >
                        <strong>
                          {_.get(
                            elements,
                            "userCreationElements.privacyElement",
                            "Privacy policy*"
                          )}{" "}
                        </strong>
                      </a>
                    </span>
                  </div>
                </FormGroup>
              </Col>{" "}
            </Row>
            <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
              <CustomButton
                customType={"button"}
                name={_.get(
                  elements,
                  "userCreationElements.backButtonElement",
                  "Back"
                )}
                customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                customClick={handleBackButton}
              />
              <CustomButton
                customType={"submit"}
                name={_.get(
                  elements,
                  "userCreationElements.submitButtonElement",
                  "Create Account"
                )}
                customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
              />
            </div>
          </CardBody>
        </Card>
      </Form>
    </div>
  );
}
